import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import Navbar from "./global-components/navbar-v4";
import VideoV4 from "./section-components/video-v4";
import Aboutv1 from "./section-components/about-v1";
import Counter from "./section-components/counter-v1";
import PortfolioV1 from "./section-components/portfolio-v2";
import VideoV1 from "./section-components/video-v1";
import Contact from "./contact";
import CallToActionV1 from "./section-components/call-to-action-v1";
import Footer from "./global-components/footer";

const Home_V1 = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div>
      <Navbar />

      <div data-aos="fade-up">
        <VideoV4 />
      </div>

      <div data-aos="fade-up">
        <Aboutv1 />
      </div>

      <div data-aos="fade-up">
        <Counter />
      </div>

      <div data-aos="fade-up">
        <PortfolioV1 />
      </div>

      <div data-aos="fade-up">
        <VideoV1 />
      </div>

      <div data-aos="fade-up">
        <Contact />
      </div>

      <div data-aos="fade-up">
        <CallToActionV1 />
      </div>

      <Footer />
    </div>
  );
};

export default Home_V1;
